import Modal from "@components/atoms/Modal";
import { AskSupplierModalProps } from "./types";
import AskSupplierScreen from "./AskSupplierScreen";
import { Platform } from "react-native";
import useScreenOptionsHooks from "../../../hooks/useScreenOptionsHooks";

const AskSupplierModal = ({
  isOpen,
  onClose,
  itemDetail,
  onSuccess,
  fromReviewPage,
}: AskSupplierModalProps) => {
  const { theme, t } = useScreenOptionsHooks();
  return (
    <Modal
      headerTitle={t("askSupplier.title.text")}
      isOpen={isOpen}
      onClose={onClose}
      paddingLeft={0}
      paddingRight={0}
      paddingTop={0}
      paddingBottom={0}
      skipKeyboardAware={false}
      allowFullScreen={Platform.OS === "web" && theme.isTablet ? true : false}
    >
      <AskSupplierScreen
        itemDetail={itemDetail}
        onClose={onClose}
        onSuccess={onSuccess}
        fromReviewPage={fromReviewPage}
      />
    </Modal>
  );
};

export default AskSupplierModal;
